import { useEffect, useRef } from "react";

/**
 * Runs `onOnce` only the first time `condition` becomes true (per component mount).
 */
export function useOnceWhen(condition: boolean, onOnce: () => void) {
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    if (condition) {
      ranRef.current = true;
      onOnce();
    }
  }, [condition, onOnce]);
}
